/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_Progress_CompleteInputs */

const cs_deal_splits_progress_complete = /** @type {(inputs: Deal_Splits_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plně přiděleno`)
};

const en_deal_splits_progress_complete = /** @type {(inputs: Deal_Splits_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fully allocated`)
};

/**
* | output |
* | --- |
* | "Fully allocated" |
*
* @param {Deal_Splits_Progress_CompleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_progress_complete = /** @type {((inputs?: Deal_Splits_Progress_CompleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Progress_CompleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_progress_complete(inputs)
	return cs_deal_splits_progress_complete(inputs)
});